import * as React from 'react'
import { connect } from 'react-redux'
import { AnalyticsShareModal } from './AnalyticsShareModal'
import { generateShareToken } from 'features/Auth/Auth.actions'

export interface IAnalyticsShareModalContainerProps {}

const stateToProps = ({ auth }) => ({
  shareToken: auth.shareToken,
  loading: auth.shareTokenLoading,
})

export const dispatchToProps = {
  generateShareToken,
}

export const AnalyticsShareModalContainer = connect(
  stateToProps,
  dispatchToProps
)(AnalyticsShareModal) as React.SFC<IAnalyticsShareModalContainerProps>



// WEBPACK FOOTER //
// src/features/CallAnalytics/AnalyticsShareModal/AnalyticsShareModal.container.ts